import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useCurrentUser } from '../../auth/currentUserContext';
import { ChecklistOverviewPage } from './ChecklistOverviewPage';
import { getChecklistLandingPath } from './checklistNavigation';

/**
 * A checklist overview is only useful when the user can choose between units.
 * Single-unit users go straight to the report details page, including when
 * they navigate to the overview URL directly.
 */
export function ChecklistOverviewRoute() {
  const { id } = useParams<{ id: string }>();
  const { search } = useLocation();
  const { units } = useCurrentUser();

  if (id !== undefined && units.length === 1) {
    return (
      <Navigate
        to={`${getChecklistLandingPath(id, units.length)}${search}`}
        replace
      />
    );
  }

  return <ChecklistOverviewPage />;
}
